/** @typedef {import('@/models/CreateTodo').Todo} Todo */
import { supabase } from '@/lib/supabase';
import { createTodo } from '@/models/CreateTodo';

/**
 * DBからTodos取得
 * @param {string} userId
 * @returns {Promise<Map<number, Todo>>} todoIdをキーとしたMap
 */
export async function getAll(userId) {
  if (!userId) {
    console.log('ログインしてください。');
    return new Map();
  }
  try {
    const { data, error } = await supabase
      .from('todos')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: true }); //新しい順

    if (error) {
      throw error;
    } else {
      return new Map(
        data.map((row) => {
          const todo = createTodo(row);
          return [todo.todoId, todo];
        }),
      );
    }
  } catch (error) {
    console.error('Error fetching todos:', error);
    return new Map();
  }
}

/**
 * TodoをDBに追加
 * @param {object} user - ユーザーオブジェクト
 * @param {Todo} todo - モデル化済みTodo
 * @returns {Promise<Todo>} DB登録後のTodo
 */
export async function addTodoToDatabase(userId, todo) {
  const { data, error } = await supabase
    .from('todos')
    .insert({
      user_id: userId,
      todo: todo.todo,
      updated_at: new Date().toISOString(),
    })
    .select();

  // insertの結果
  if (error) {
    console.error('Error adding todo:', error);
    throw error;
  } else {
    console.log('inserted todo:', data);
  }

  return createTodo(data[0]);
}

/**
 * Todoの完了ステータスを更新
 * @param {Todo} todo
 * @returns {Promise<Todo>} 更新後のTodo
 */
export async function completedTodoToDatabase(todo) {
  if (!todo.todoId) {
    throw new Error('Todo Id がありません');
  }
  const { data, error } = await supabase
    .from('todos')
    .update({
      completed_at: todo.completedAt,
      updated_at: new Date().toISOString(),
    })
    .eq('todo_id', todo.todoId)
    .select();
  if (error) {
    console.error('Error deleting todo:', error);
    throw error;
  }
  return createTodo(data[0]);
}

/**
 * Todoの内容を更新
 * @param {Todo} todo
 * @returns {Promise<Todo>}
 */
export async function updateTodoInDatabase(userId, todo) {
  const { data, error } = await supabase
    .from('todos')
    .update({
      todo: todo.todo,
      updated_at: new Date().toISOString(),
    })
    .eq('todo_id', todo.todoId)
    .eq('user_id', userId)
    .select();

  if (error) throw error;
  return createTodo(data[0]);
}

/**
 * Todoを削除（論理削除）
 * @param {Todo} todo
 * @returns {Promise<Todo>} 削除後のTodo
 */
export async function removeTodoToDatabase(todo) {
  if (!todo.todoId) {
    throw new Error('Todo ID がありません');
  }
  const { data, error } = await supabase
    .from('todos')
    .update({
      deleted_at: todo.deletedAt,
      updated_at: new Date().toISOString(),
    })
    .eq('todo_id', todo.todoId)
    .select();

  if (error) {
    console.error('Error deleting todo:', error);
    throw error;
  }
  return createTodo(data[0]);
}
